var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14280_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16032 13.5599L1.75032 6.55986C1.74179 6.48934 1.74839 6.41782 1.76967 6.35005C1.79095 6.28228 1.82643 6.21982 1.87374 6.16684C1.92104 6.11385 1.9791 6.07156 2.04403 6.04277C2.10897 6.01397 2.17929 5.99935 2.25032 5.99986H6.86032C6.9724 6.00055 7.08113 6.03815 7.1697 6.10684C7.25827 6.17553 7.32175 6.27148 7.35032 6.37986L7.75032 7.99986H14.2503C14.3195 7.99964 14.3879 8.01377 14.4514 8.04136C14.5148 8.06895 14.5718 8.1094 14.6188 8.16015C14.6658 8.21091 14.7017 8.27086 14.7244 8.33621C14.747 8.40157 14.7559 8.47092 14.7503 8.53986L14.3603 13.5399C14.3402 13.791 14.226 14.0252 14.0406 14.1958C13.8552 14.3664 13.6122 14.4607 13.3603 14.4599H3.16032C2.91155 14.4611 2.67125 14.3696 2.48634 14.2032C2.30143 14.0367 2.18519 13.8074 2.16032 13.5599Z",
    stroke: "#007293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75006 3.99985V1.99985C4.75006 1.86724 4.80274 1.74006 4.89651 1.64629C4.99028 1.55253 5.11745 1.49985 5.25006 1.49985H13.7501C13.8827 1.49985 14.0098 1.55253 14.1036 1.64629C14.1974 1.74006 14.2501 1.86724 14.2501 1.99985V5.99985",
    stroke: "#007293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75012 3.99991H11.7501",
    stroke: "#007293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14280_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1.25 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFolder);
export default __webpack_public_path__ + "static/media/fileFolder.5a46192c3369ba06d10985b54e71276c.svg";
export { ForwardRef as ReactComponent };